/**
 * Construction de DOM sans innerHTML.
 *
 * Tout le contenu vient d'un fichier fourni par l'utilisateur : il est inséré
 * via textContent, jamais via innerHTML. Aucun script, aucun attribut d'événement
 * inline — la CSP (`script-src 'self'`) n'a pas à être assouplie.
 */

export type Child = Node | string | number | null | undefined | false;

type AttrValue = string | number | boolean | null | undefined;

export interface Attrs {
  class?: string;
  [key: string]: AttrValue;
}

export function h<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Attrs | null = null,
  ...children: Child[]
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (attrs) {
    for (const [key, value] of Object.entries(attrs)) {
      if (value === null || value === undefined || value === false) continue;
      if (key === 'class') {
        el.className = String(value);
        continue;
      }
      if (value === true) {
        el.setAttribute(key, '');
        continue;
      }
      el.setAttribute(key, String(value));
    }
  }
  append(el, children);
  return el;
}

export function append(parent: Node, children: Child[]): void {
  for (const child of children) {
    if (child === null || child === undefined || child === false) continue;
    if (typeof child === 'number') {
      parent.appendChild(document.createTextNode(String(child)));
    } else if (typeof child === 'string') {
      parent.appendChild(document.createTextNode(child));
    } else {
      parent.appendChild(child);
    }
  }
}

/** Paragraphe de valeur absente, avec le vocabulaire imposé. */
export function absent(text: string): HTMLElement {
  return h('span', { class: 'absent' }, text);
}

export function clear(node: Element): void {
  while (node.firstChild) node.removeChild(node.firstChild);
}
